module.exports = __webpack_public_path__ + "img/xinlihua.202cab8c.jpg";